import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getEquipmentsById } from "components/axios/equipmentAxios";
import EquipmentForm from "components/inner/equipment/Form";
import EquipmentSpec from "components/inner/equipment/Spec";
import { useState } from "react";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import EquipmentGateway from "components/inner/equipment/Gateways";
import EquipmentSensor from "components/inner/equipment/Sensors";
import EquipmentStatus from "components/inner/equipment/Status";
import { getGatewaysByQuery } from "components/axios/iotAxios";
import FormSubList from "components/inner/equipment/FormSubList";

const EquipmentModifySetting = () => {
    const { t } = useTranslation();
    const { id } = useParams();

    /** 데이터 상태 */
    const [info, setInfo] = useState(null);
    const [equipmentGateways, setEquipmentGateways] = useState(null);
    const [equipmentNoList, setEquipmentNoList] = useState(null);

    /** 제어 상태 */
    // const [isLoading, setIsLoading] = useState(true);
    const [refreshKey, setRefreshKey] = useState(0);

    /** ================================
     * 설비 기본 정보 조회
     * ================================ */
    useEffect(() => {
        if (!id) return;

        // setIsLoading(true);

        getEquipmentsById(id)
        .then((res) => {
            setInfo(res);
        })
        .finally(() => {
            // setIsLoading(false);
        });
    }, [id, refreshKey]);

    /** ================================
     * Gateway 목록 조회
     * ================================ */
    useEffect(() => {
        if (!id) return;

        getGatewaysByQuery({ "equipments.equipment.id": id, size: 400 })
        .then((res) => {
            if (res && res._embedded) {
            setEquipmentGateways(res._embedded.gatewayDTOes);
            } else {
            setEquipmentGateways(null);
            }
        });
    }, [id, refreshKey]);

    /** ================================
     * 자식에게 넘길 refresh 함수
     * ================================ */
    const onRefresh = () => {
        setRefreshKey((prev) => prev + 1);
    };

    /** ================================
     * Render
     * ================================ */
    // if (isLoading) return null;

    return (
        <div className="cal">
            <div className="scroll_table">
                <Row style={{width:"100%"}}>
                    <Col sm={8} className="main_left">
                        <EquipmentForm info={info} onRefresh={onRefresh} setEquipmentNoList={setEquipmentNoList} />
                        <EquipmentSpec info={info} />
                        <EquipmentGateway info={info} equipmentGateways={equipmentGateways} />
                        <EquipmentSensor info={info} />
                    </Col>

                    <Col sm={4} className="main_right">
                        {equipmentNoList && <FormSubList equipmentNoList={equipmentNoList}/>}
                        <EquipmentStatus info={info} />
                    </Col>

                    <div style={{marginTop:"10px"}}>
                        <Link to={'/setting/basic/equipment'+window.location.search}><Button variant="contained" color="primary">{t('message.common.btn.list')}</Button></Link>
                    </div>
                </Row>
            </div>
        </div>
    );
}
export default EquipmentModifySetting;